import React, { Component } from "react";
import {Button, Modal} from "react-bootstrap";
import { MAX_WIDTH_SP, TEXT_CLOSE, TYPE_NEXT_PURCHASE, TYPE_NEXT_SAVE } from '../../const'

export default class ModalLimitDesign extends Component {
  render() {
    let {
      isShowModalLimitDesign,
      handleUpdateState,
      typeNextAction
    } = this.props;

    return (
      <Modal
        show={isShowModalLimitDesign}
        aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="modal-confirm-select-new-stone modal-dialog-centered dialog_custom"
        onHide={() => handleUpdateState("isShowModalLimitDesign", false)}
        centered
      >
        <Modal.Body>
          <span>デザインを15個まで保存できます。「次へ」を押して一番古いデザインを削除して、{(typeNextAction == TYPE_NEXT_SAVE) ? 'デザインを保存' : 'カートに入れる'}を進めてください。</span>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="red" onClick={() => this.props.handleNext()}>
            次へ
          </Button>
          <Button variant="secondary" onClick={() => handleUpdateState("isShowModalLimitDesign", false)}>
            閉じる
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
